import WidgetCard from "./WidgetCard";
import ShowMoreCard from "./ShowMoreCard";
import { WidgetSection } from "../widgets.types";
import WidgetTitle from "./WidgetTitle";
import { getLang, isDeviceMobile } from "../../../Helpers/functions";

export default function ScrollableCardSection({
  widget,
  onAction,
  addingWidgetKey,
  parentIndex,
  disableActions,
}: {
  widget: WidgetSection;
  onAction: (payload: any, widgetKey: string) => void;
  addingWidgetKey: string | null;
  parentIndex: number;
  disableActions: boolean;
}) {
  if (widget.items.length === 0) return null;

  const { items, gradiantColor, borderColor, header, showMore } = widget;

  const anyItemHasOldPrice = items?.some((item) => item.oldPrice);

  return (
    <div
      className="widget-section p-4 p-md-3 custom_border_radius"
      style={{
        background: `linear-gradient(
          to bottom,
          ${gradiantColor} 0%,
          #ffffff 100%
        )`,
        border: `1px solid ${borderColor}`,
      }}
    >
      {header && <WidgetTitle data={header} />}

      <div className="widget-scroll">
        {items?.map((item, index) => (
          <WidgetCard
            key={index}
            widgetItem={item}
            anyItemHasOldPrice={anyItemHasOldPrice}
            onAction={onAction}
            isLoading={addingWidgetKey === `${parentIndex}-${index}`}
            isActionsDisabled={!!addingWidgetKey || disableActions}
            loadingKey={`${parentIndex}-${index}`}
          />
        ))}
        {showMore && (
          <ShowMoreCard
            showMore={showMore}
            anyItemHasOldPrice={anyItemHasOldPrice}
          />
        )}
      </div>
    </div>
  );
}
